
module.exports = {
  apiKey: "AIzaSyAJkJjkHeFCTixrPQsuqDgTRu5tKK7pDPc",
  authDomain: "collab-22ba6.firebaseapp.com",
  databaseURL: "https://collab-22ba6.firebaseio.com",
  projectId: "collab-22ba6",
  storageBucket: "collab-22ba6.appspot.com",
  messagingSenderId: "56182343320",
  appId: "1:56182343320:web:b0807d24ffd525283cb2ed",
  measurementId: "G-2R9ZF1ZVNX",
};